import { render, staticRenderFns } from "./FinishStudy.vue?vue&type=template&id=081e1c16&"
import script from "./FinishStudy.vue?vue&type=script&lang=js&"
export * from "./FinishStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports